const STORAGE_KEY = "cookie-consent";
const GA_ID = "G-7D5FXTGVX2";

export type ConsentStatus = "accepted" | "declined" | null;

export const getConsent = (): ConsentStatus => {
  try {
    const val = localStorage.getItem(STORAGE_KEY);
    if (val === "accepted" || val === "declined") return val;
    return null;
  } catch {
    return null;
  }
};

export const setConsent = (status: "accepted" | "declined") => {
  try {
    localStorage.setItem(STORAGE_KEY, status);
  } catch {
    // storage unavailable
  }
};

export const clearConsent = () => {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    // storage unavailable
  }
};

export const loadGA4 = () => {
  // Prevent double-loading
  if (document.querySelector(`script[src*="googletagmanager.com/gtag"]`)) return;

  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  window.gtag = function () {
    // eslint-disable-next-line prefer-rest-params
    window.dataLayer.push(arguments);
  };
  window.gtag("js", new Date());
  window.gtag("config", GA_ID);
  window.__GA_ID__ = GA_ID;
};
